/**
 * Created by pmnia on 12/03/15.
 */
(function () {
    'use strict';

    angular
        .module('app.login')
        .directive('obtUpdateSectionDirective', obtUpdateSectionDirective);

    function obtUpdateSectionDirective () {
        var directive = {
          scope:{
            data:'=?',
            pageId:'@?',
            pageSectionId:'@?',
            type:'@?',
            anchor:'@?'
          },
            controller:obtSectionUpdateCtlr,
            restrict:'EA',
            replace:true,
             templateUrl:'app/login/updateSectionDirective/updateSectionDirective.html'



              };
        return directive;
    }

    //obtLoginCtlr.$inject=['loginServices', '$state', '$stateParams', 'logger'];
    /*@ngInject*/
    function obtSectionUpdateCtlr($scope,loginServices, $state, $stateParams, logger,$rootScope){

      $scope.getData = function (){
        var obj = {};
        if($scope.type === '7' || $scope.type === '9'){
          var items = $rootScope.pageSection ;
                angular.forEach(items , function (value){
                          if(value.anchor === $scope.anchor && value.data){
                                  $scope.data = value.data ;
                          }
               })
        }

          obj = {type : $scope.type , anchor : $scope.anchor ,data : $scope.data , pageId : $scope.pageId ,pageSectionId : $scope.pageSectionId};
           console.log(obj , 'my objet');
           return obj;
      }
    }
    //function link(scope, element, attrs) {
    //}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/login/updateSectionDirective/updateSectionDirective.js
 ** module id = 229
 ** module chunks = 0
 **/